import { HomeAlbumPage } from './HomeAlbumPage';
export default HomeAlbumPage;
